import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import subscribeInboxUnreadCount from './inbox_unread_count_store';

const UNREAD_DISPLAY_CAP = 99;

function formatUnreadCount(count) {
  if (count > UNREAD_DISPLAY_CAP) {
    return `${UNREAD_DISPLAY_CAP}+`;
  }
  return count;
}

function InboxIconWithUnreadCount({
                                    active, link, mobile, userId, v2MessagingEnabled,
                                  }) {
  const [numUnreadConversations, setNumUnreadConversation] = useState(0);

  // Both responsive variants of the navbar mount this component, but the underlying
  // Supabase channel + fetch is shared via the singleton store — see inbox_unread_count_store.js.
  useEffect(() => {
    if (!v2MessagingEnabled || !userId) {
      return undefined;
    }
    return subscribeInboxUnreadCount(userId, setNumUnreadConversation);
  }, [v2MessagingEnabled, userId]);

  return (
    <li className="nav-item">
      <a href={link} className={`nav-link ${mobile ? 'nav-link-mobile' : ''} ${active ? 'active' : ''}`}>
        {numUnreadConversations > 0 && (
          <>
            <span
              className="badge rounded-pill"
              style={{ position: 'relative', top: '-2px', backgroundColor: '#d50b3e' }}
            >
              {formatUnreadCount(numUnreadConversations)}
            </span>&nbsp;
          </>
        )}

        {mobile && (
          <><i className="fa fa-inbox" /> Inbox</>
        )}
        {!mobile && (
          <i className="fa-solid fa-inbox fa-lg" />
        )}
      </a>
    </li>
  );
}

InboxIconWithUnreadCount.propTypes = {
  active: PropTypes.bool,
  link: PropTypes.string.isRequired,
  mobile: PropTypes.bool,
  userId: PropTypes.number,
  v2MessagingEnabled: PropTypes.bool,
};

InboxIconWithUnreadCount.defaultProps = {
  active: false,
  mobile: false,
  userId: null,
  v2MessagingEnabled: false,
};

export default InboxIconWithUnreadCount;
